export const userInfo = state => state.userInfo
export const permissions = state => state.permissions



// WEBPACK FOOTER //
// ./src/store/getters.js